import type { Plugin, Action } from "@elizaos/core";
import { toV2ActionExample } from "@elizaos/core/v1";
import getMarkets from "./actions/getMarkets";
import getPrice from "./actions/getPrice";
import getPricePerAddress from "./actions/getPricePerAddress";
import getTopGainersLosers from "./actions/getTopGainersLosers";
import getTrending from "./actions/getTrending";
import getTrendingPools from "./actions/getTrendingPools";
import getNewlyListed from "./actions/getNewlyListed";
import getNetworkTrendingPools from "./actions/getNetworkTrendingPools";
import getNetworkNewPools from "./actions/getNetworkNewPools";
import { categoriesProvider } from "./providers/categoriesProvider";
import { coinsProvider } from "./providers/coinsProvider";
import { networksProvider } from "./providers/networkProvider";

// Convert v1 actions to v2 format
function convertV1ActionToV2(v1Action: any): Action {
  return {
    ...v1Action,
    examples:
      v1Action.examples?.map((conversationExamples: any[]) =>
        conversationExamples.map((example: any) => ({
          ...example,
          name: example.user, // Add name property from user field
          content: toV2ActionExample(example).content,
        }))
      ) || [],
  };
}

// Convert all actions from v1 to v2 format
const v2Actions = [
  getPrice,
  getPricePerAddress,
  getTrending,
  getTrendingPools,
  getMarkets,
  getTopGainersLosers,
  getNewlyListed,
  getNetworkTrendingPools,
  getNetworkNewPools,
].map(convertV1ActionToV2);

export const coingeckoPlugin: Plugin = {
  name: "coingecko",
  description: "CoinGecko Plugin for Eliza",
  actions: v2Actions,
  evaluators: [],
  providers: [categoriesProvider, coinsProvider, networksProvider],
};

export default coingeckoPlugin;
